import * as React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { FormControl, FormHelperText, Input, InputLabel } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
// import { Alert } from 'react-alert'

/**
 * Shows different features to choose from
 * @returns 
 */
export default function DynamicCameraCard({descr, resolutionsize, title, descr2, title2, img, unit, unit2, FOV, sensorSize, cameraResolutionVert, cameraResolutionHor, focalLength, roundedResX, roundedResY, megaPixel}) {

  const navigate = useNavigate();

    const [blur, setBlur] = React.useState("");
    const [speed, setSpeed] = React.useState("");
    const [color, setcolor] = React.useState("Blue");

  const handleChange = (e, type) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      if (type === "blur"){
        setBlur(e.target.value);
      } else if (type === "speed"){
        setSpeed(e.target.value);
      }
      
      console.log(blur)
      console.log(speed)
    } else {
        setcolor("red")
        console.log(color)
    }
  };

  const submit = () => {
    const regex = /^[0-9\b]+$/;
    if ((regex.test(blur)) && (regex.test(speed))){
        const maxexposuretime = (blur * FOV / resolutionsize) / speed
        console.log(maxexposuretime)
      navigate(`/listofsuppliers`,{ state: { staticObject: false, maxexposuretime: maxexposuretime, FOV:FOV, cameraResolutionVert:cameraResolutionVert, cameraResolutionHor:cameraResolutionHor, focalLength:focalLength, roundedResX:roundedResX, roundedResY:roundedResY, megaPixel:megaPixel} })
    } else if (!regex.test(blur)) {
      alert("Blur is not correct or not filled in, try again.")
    } else if (!regex.test(speed)) {
      alert("Speed is not correct or not filled in, try again.")
    }
  }

  return (
    <Card sx={{ maxWidth: 900}} style={{ border: "3px solid #5BDCDF" }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" >
          {title}
        </Typography>
        <Typography variant="body2" color="secondary">
          {descr}
        </Typography>
        <FormControl error={false}>
            <InputLabel htmlFor="my-input">{unit}</InputLabel>
            <Input id="my-input" aria-describedby="my-helper-text" onChange={(e) => handleChange(e, "blur")} value={blur}></Input>
            
            <FormHelperText id="my-helper-text">Only positive numbers are accepted.</FormHelperText>
        </FormControl>

        <Typography gutterBottom variant="h5" component="div" >
          {title2}
        </Typography>
        <Typography variant="body2" color="secondary">
          {descr2}
        </Typography>
        <FormControl error={false}>
            <InputLabel htmlFor="my-input">{unit2}</InputLabel>
            <Input id="my-input" aria-describedby="my-helper-text" onChange={(e) => handleChange(e, "speed")} value={speed}></Input>
            
            <FormHelperText id="my-helper-text">Only positive numbers are accepted.</FormHelperText>
        </FormControl>
        
        <Typography variant="body2" color="secondary">
        <img alt="" style={{ width: "100%", height: "", maxWidth: 500, marginTop: 50 }} src={img}></img>
        </Typography>

        

        </CardContent>
      <div style={{display:"flex", justifyContent:"center", width: "100%"}}>
      <CardActions>
        <Button variant="contained" color="secondary" size="small" onClick={submit}>Go to the next step</Button>
      </CardActions>
      </div>
    </Card>
  );
}